<div class="dashboard-root text-sm text-slate-600 dark:text-slate-300">
  
  <!-- ═════ SIDEBAR PANEL ═════ -->
  <aside class="w-full md:w-80 bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm border-r border-slate-100/50 dark:border-slate-800/50 flex flex-col h-1/3 md:h-full z-30 shadow-xl">
    <div class="p-6 border-b border-slate-100/50 dark:border-slate-800/50">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-2xl bg-amber-100 dark:bg-amber-900/30 text-amber-500 flex items-center justify-center shadow-inner">
          <span class="material-icons">dashboard</span>
        </div>
        <div>
          <h1 class="text-lg font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">Interactive Canvas</h1>
          <p class="text-xs text-slate-400 dark:text-slate-500 font-medium">Drag widgets below into dashboard</p>
        </div>
      </div>
    </div>

    <!-- Custom Autocomplete Site Selector -->
    <div class="px-6 py-4 bg-slate-50/50 dark:bg-slate-850/20 border-b border-slate-100/50 dark:border-slate-800/50 relative">
      <label class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2 block">เลือกสถานที่จอดรถ (Location):</label>
      
      <div class="relative">
        <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-sm">place</span>
        <input type="text" 
               [ngModel]="searchSiteText()"
               (ngModelChange)="searchSiteText.set($event)"
               (focus)="showSiteDropdown.set(true)" 
               (blur)="closeSiteDropdown()"
               placeholder="ค้นหาหรือเลือกสถานที่..." 
               class="w-full pl-9 pr-8 py-2 bg-slate-100 dark:bg-slate-800 rounded-xl border border-slate-200/50 dark:border-slate-700/55 text-xs font-bold focus:ring-2 focus:ring-amber-200 focus:outline-none text-slate-700 dark:text-slate-200 transition-all">
        <span class="absolute right-2 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-xs">expand_more</span>
      </div>

      <!-- Autocomplete Dropdown List -->
      <div *ngIf="showSiteDropdown()"
           (mousedown)="$event.preventDefault()"
           class="absolute left-6 right-6 mt-1.5 bg-white/95 dark:bg-slate-900/95 backdrop-blur-md border border-slate-150 dark:border-slate-800 shadow-2xl rounded-xl max-h-40 overflow-y-auto z-40 custom-scrollbar animate-fade-in">
        <div *ngFor="let site of filteredSites()" 
             (click)="selectSite(site)"
             class="px-4 py-2 hover:bg-amber-50 dark:hover:bg-amber-900/10 hover:text-amber-500 font-bold text-xs text-slate-700 dark:text-slate-300 transition-colors cursor-pointer flex items-center justify-between">
          <span>{{ site.name }}</span>
          <span *ngIf="selectedSite()?.id === site.id" class="material-icons text-amber-500 text-[16px]">check</span>
        </div>
        <div *ngIf="filteredSites().length === 0" class="px-4 py-3 text-center text-xs text-slate-400">
          ไม่พบสถานที่
        </div>
      </div>
    </div>

    <!-- Draggable Widgets Accordion List -->
    <div class="flex-1 overflow-y-auto p-4 custom-scrollbar" 
         cdkDropList 
         [cdkDropListConnectedTo]="['canvas-board']"
         id="sidebar-widgets">
      
      <div *ngFor="let cat of categories" class="mb-4">
        <!-- Accordion Header -->
        <button (click)="toggleCategory(cat.name)" 
                class="flex justify-between items-center w-full px-3 py-2 bg-slate-50/80 dark:bg-slate-800/40 hover:bg-slate-100 hover:text-amber-500 rounded-xl font-extrabold text-xs text-slate-700 dark:text-slate-200 transition-all tracking-tight cursor-pointer">
          <span class="flex items-center gap-2">
            <span class="material-icons text-base text-amber-500">{{ cat.icon }}</span>
            {{ cat.name }}
          </span>
          <span class="material-icons text-xs transition-transform duration-200"
                [class.rotate-180]="expandedCategories()[cat.name]">
            expand_more
          </span>
        </button>

        <!-- Draggable cards (visible only when category is expanded) -->
        <div *ngIf="expandedCategories()[cat.name]" 
             class="mt-2 pl-1 space-y-3 animate-fade-in">
          <div *ngFor="let item of cat.items" 
               [cdkDragData]="item"
               cdkDrag 
               class="p-3 bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-800 hover:border-amber-300 dark:hover:border-amber-600 hover:shadow-md rounded-xl cursor-grab transition-all group active:cursor-grabbing">
            
            <div class="flex items-center gap-3">
              <div class="w-8 h-8 rounded-lg bg-amber-50 dark:bg-amber-900/10 text-amber-500 flex items-center justify-center group-hover:scale-105 transition-transform">
                <span class="material-icons text-lg">{{ item.icon }}</span>
              </div>
              <div class="flex-1 min-w-0">
                <h4 class="font-bold text-slate-800 dark:text-slate-200 text-xs truncate mb-0.5">{{ item.title }}</h4>
                <p class="text-[10px] text-slate-400 dark:text-slate-500 leading-normal truncate">{{ item.desc }}</p>
              </div>
            </div>

            <div *cdkDragPlaceholder class="border-2 border-dashed border-amber-300 h-16 rounded-xl bg-amber-50/10"></div>
          </div>
        </div>

      </div>

    </div>

    <!-- Help guidelines -->
    <div class="p-4 border-t border-slate-100/50 dark:border-slate-800/50 text-[11px] text-slate-400 dark:text-slate-500 bg-slate-50/50 dark:bg-slate-850/50">
      <p class="font-bold mb-1 flex items-center gap-1"><span class="material-icons text-xs">help_outline</span> Instructions</p>
      <ul class="list-disc pl-4 space-y-1">
        <li>ลากการ์ดเครื่องมือจอดลงบนพื้นที่ Canvas</li>
        <li>คลิกเมาส์ค้างที่จุด Anchor เพื่อโยงเส้นเปรียบเทียบ</li>
        <li>สามารถกำหนดช่วงวันที่ได้แยกอิสระในแต่ละการ์ด</li>
        <li>สามารถกดดาวน์โหลดรายงานรายงานในรูปแบบไฟล์ Excel</li>
      </ul>
    </div>
  </aside>

  <!-- ═════ DASHBOARD CANVAS ═════ -->
  <main class="flex-1 relative flex flex-col md:h-full overflow-hidden">
    
    <!-- Canvas workspace header -->
    <header class="h-16 px-6 border-b border-slate-100/50 dark:border-slate-800/50 bg-white/95 dark:bg-slate-900/95 flex items-center justify-between z-10">
      <div class="flex items-center gap-3">
        <span class="w-2.5 h-2.5 rounded-full bg-emerald-500 animate-ping"></span>
        <h2 class="text-sm font-bold text-slate-700 dark:text-slate-200">Dashboard Canvas Workspace</h2>
      </div>
      <div class="flex items-center gap-2">
        <button (click)="connections.set([]); clearComparison()" 
                *ngIf="connections().length > 0"
                class="px-3 py-1.5 text-xs text-rose-500 bg-rose-50 dark:bg-rose-950/20 rounded-xl hover:bg-rose-100 transition-colors font-bold flex items-center gap-1 border border-rose-100/50 cursor-pointer">
          <span class="material-icons text-sm">remove_road</span> ล้างเส้นเชื่อม
        </button>
        <button (click)="nodes.set([]); connections.set([]); clearComparison()"
                *ngIf="nodes().length > 0"
                class="px-3 py-1.5 text-xs text-slate-500 bg-slate-100 dark:bg-slate-850 rounded-xl hover:bg-slate-200 transition-colors font-bold flex items-center gap-1 cursor-pointer">
          <span class="material-icons text-sm">clear_all</span> ล้างบอร์ด
        </button>
      </div>
    </header>

    <!-- Canvas area with dot grid style -->
    <div class="flex-1 relative overflow-auto custom-scrollbar bg-dots" 
         id="canvas-board"
         cdkDropList
         [cdkDropListData]="nodes()"
         (cdkDropListDropped)="onDrop($event)">
      
      <!-- Scrollable workspace container size holder -->
      <div class="absolute inset-0 pointer-events-none" style="width: 3000px; height: 3000px; z-index: 0;"></div>
      
      <!-- SVG Lines Overlay container -->
      <svg class="absolute inset-0 pointer-events-none z-0" style="width: 3000px; height: 3000px;">
        <defs>
          <linearGradient id="line-grad" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stop-color="#fbbf24" />
            <stop offset="100%" stop-color="#f59e0b" />
          </linearGradient>
          <linearGradient id="line-grad-active" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stop-color="#fbbf24" />
            <stop offset="50%" stop-color="#ffffff" />
            <stop offset="100%" stop-color="#f59e0b" />
          </linearGradient>
        </defs>

        <!-- Dynamic Connection lines -->
        <g *ngFor="let line of renderedLines()" class="pointer-events-auto cursor-pointer">
          <path [attr.d]="line.path" 
                (click)="selectConnection(line.connection)"
                [class.selected-path]="selectedConnection()?.id === line.id"
                class="connection-line-shadow" 
                fill="none" 
                stroke="#d1d5db" 
                stroke-width="6" />
          
          <path [attr.d]="line.path" 
                (click)="selectConnection(line.connection)"
                [class.selected-path]="selectedConnection()?.id === line.id"
                class="connection-line" 
                fill="none" 
                [attr.stroke]="selectedConnection()?.id === line.id ? 'url(#line-grad-active)' : 'url(#line-grad)'" 
                stroke-width="3" />

          <!-- Value comparison badge attached on connection lines -->
          <foreignObject *ngIf="line.differenceLabel"
                         [attr.x]="line.midX - 35" 
                         [attr.y]="line.midY - 14" 
                         width="70" 
                         height="28" 
                         class="pointer-events-none">
            <div class="bg-amber-500 text-white text-[10px] font-black rounded-full shadow-lg border border-amber-300 py-1 text-center scale-95 hover:scale-100 transition-transform select-none">
              {{ line.differenceLabel }}
            </div>
          </foreignObject>
        </g>

        <!-- Temporary line drawn on active dragging -->
        <path *ngIf="drawingConnection() as activeLine"
              [attr.d]="'M ' + activeLine.x1 + ' ' + activeLine.y1 + ' C ' + (activeLine.x1 + (activeLine.fromAnchor === 'right' ? 80 : -80)) + ' ' + activeLine.y1 + ', ' + activeLine.x2 + ' ' + activeLine.y2 + ', ' + activeLine.x2 + ' ' + activeLine.y2"
              fill="none"
              stroke="#f59e0b"
              stroke-width="3"
              stroke-dasharray="6,4"
              class="animate-dash" />
      </svg>

      <!-- Draggable Node Cards -->
      <div *ngFor="let node of nodes()" 
           cdkDrag 
           [style.left.px]="node.x"
           [style.top.px]="node.y"
           (cdkDragMoved)="onNodeMoved($event, node)"
           (cdkDragEnded)="onNodeDragEnded($event, node)"
           class="absolute w-[320px] bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm border border-slate-100/50 dark:border-slate-800/50 rounded-2xl shadow-2xl z-10 transition-shadow hover:shadow-amber-400/5 hover:border-amber-400/30 overflow-visible group select-none">
        
        <!-- Loading state panel inside card -->
        <div *ngIf="node.isLoading" class="absolute inset-0 bg-white/80 dark:bg-slate-900/80 rounded-2xl flex flex-col items-center justify-center z-20 backdrop-blur-xs">
          <div class="w-8 h-8 rounded-full border-3 border-amber-200 border-t-amber-500 animate-spin mb-2"></div>
          <span class="text-xs text-amber-500 font-bold">ยิง API ดึงข้อมูล...</span>
        </div>

        <!-- Connection Anchor Points (Left & Right margins) -->
        <div [attr.id]="'anchor-' + node.id + '-left'" 
             (mousedown)="startConnectionDrawing($event, node, 'left')"
             (mouseup)="establishConnection($event, node, 'left')"
             class="absolute -left-2 top-1/2 -translate-y-1/2 w-4 h-4 rounded-full bg-slate-350 hover:bg-amber-450 border-2 border-white dark:border-slate-900 shadow-md cursor-crosshair z-30 transition-all scale-75 group-hover:scale-100 active:scale-125">
        </div>
        <div [attr.id]="'anchor-' + node.id + '-right'" 
             (mousedown)="startConnectionDrawing($event, node, 'right')"
             (mouseup)="establishConnection($event, node, 'right')"
             class="absolute -right-2 top-1/2 -translate-y-1/2 w-4 h-4 rounded-full bg-slate-350 hover:bg-amber-450 border-2 border-white dark:border-slate-900 shadow-md cursor-crosshair z-30 transition-all scale-75 group-hover:scale-100 active:scale-125">
        </div>

        <!-- Card Header / Drag Handle -->
        <div cdkDragHandle class="px-5 py-4 border-b border-slate-100/50 dark:border-slate-800/50 flex items-center justify-between cursor-move bg-slate-50/50 dark:bg-slate-800/20 rounded-t-2xl">
          <span class="font-extrabold text-slate-850 dark:text-slate-100 tracking-tight flex items-center gap-1.5">
            <span class="material-icons text-base text-amber-500">
              {{ node.type === 'total-cars' ? 'directions_car' : node.type === 'revenue' ? 'payments' : node.type === 'occupancy' ? 'donut_large' : node.type === 'transactions' ? 'history' : 'leaderboard' }}
            </span>
            {{ node.title }}
          </span>
          <div class="flex items-center gap-1">
            <!-- Excel Export button -->
            <button (click)="exportToExcel($event, node)" 
                    *ngIf="node.data"
                    class="text-slate-400 hover:text-emerald-500 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors p-1 rounded-lg cursor-pointer flex items-center">
              <span class="material-icons text-[16px]">download</span>
            </button>
            <!-- Delete Card button -->
            <button (click)="removeNode(node.id)" class="text-slate-400 hover:text-rose-500 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors p-1 rounded-lg cursor-pointer flex items-center">
              <span class="material-icons text-[16px]">close</span>
            </button>
          </div>
        </div>

        <!-- Card Material Date Range Selector overlay -->
        <div class="px-5 py-2.5 border-b border-slate-100/50 dark:border-slate-800/50 bg-slate-50/20">
          <div class="flex items-center justify-between gap-2 bg-slate-50 dark:bg-slate-800/50 px-3 py-1.5 rounded-xl border border-slate-200/50 dark:border-slate-700/55 hover:border-amber-300 cursor-pointer text-[10px] text-slate-500 dark:text-slate-400 font-bold relative transition-all"
               (click)="picker.open()">
            <span class="flex items-center gap-1.5">
              <span class="material-icons text-xs text-amber-500">date_range</span>
              {{ formatDate(node.startDate) }} — {{ formatDate(node.endDate) }}
            </span>
            <span class="material-icons text-xs text-slate-400">expand_more</span>
            
            <!-- Hidden Material range input wrapper -->
            <mat-date-range-input [rangePicker]="picker" class="absolute inset-0 opacity-0 pointer-events-none">
              <input matStartDate [(ngModel)]="node.startDate" (dateChange)="onNodeDateChanged(node)">
              <input matEndDate [(ngModel)]="node.endDate" (dateChange)="onNodeDateChanged(node)">
            </mat-date-range-input>
            <mat-date-range-picker #picker panelClass="modern-yellow-datepicker"></mat-date-range-picker>
          </div>
        </div>

        <!-- Card Inner Content based on widget type -->
        <div class="p-5 overflow-hidden">
          
          <!-- TYPE A: TOTAL ACTIVE CARS -->
          <div *ngIf="node.type === 'total-cars' && node.data" class="animate-fade-in">
            <div class="grid grid-cols-2 gap-4">
              <div class="bg-amber-500/5 dark:bg-amber-400/5 p-3.5 rounded-xl border border-amber-500/10">
                <p class="text-[10px] uppercase font-black text-amber-600 dark:text-amber-400 tracking-widest mb-1">Active</p>
                <h3 class="text-xl font-black text-slate-800 dark:text-slate-100">{{ node.data.activeCars | number }}</h3>
              </div>
              <div class="bg-slate-500/5 dark:bg-slate-450/5 p-3.5 rounded-xl border border-slate-200/50 dark:border-slate-800/50">
                <p class="text-[10px] uppercase font-black text-slate-400 tracking-widest mb-1">Registered</p>
                <h3 class="text-xl font-black text-slate-800 dark:text-slate-100">{{ node.data.registeredCars | number }}</h3>
              </div>
            </div>
            <div class="mt-4 flex items-center justify-between">
              <span class="text-xs font-semibold text-slate-400">Activity Ratio</span>
              <span class="text-xs font-bold text-amber-500">{{ node.data.percentageActive }}%</span>
            </div>
            <div class="w-full bg-slate-100 dark:bg-slate-800 h-1.5 rounded-full overflow-hidden mt-1">
              <div class="bg-amber-500 h-full rounded-full transition-all duration-1000" [style.width]="node.data.percentageActive + '%'"></div>
            </div>
          </div>

          <!-- TYPE B: REVENUE SUMMARY -->
          <div *ngIf="node.type === 'revenue' && node.data" class="animate-fade-in">
            <div class="text-center mb-4">
              <p class="text-[10px] uppercase font-black text-slate-400 tracking-widest mb-0.5">Total Income</p>
              <h2 class="text-2xl font-black text-amber-500">฿{{ node.data.totalRevenue | number }}</h2>
            </div>
            <div class="grid grid-cols-2 gap-3 border-t border-slate-100/50 dark:border-slate-800/50 pt-4">
              <div>
                <p class="text-[9px] uppercase font-bold text-slate-400 mb-0.5">Parking Fee</p>
                <h4 class="font-extrabold text-sm text-slate-700 dark:text-slate-350">฿{{ node.data.parkingRevenue | number }}</h4>
              </div>
              <div>
                <p class="text-[9px] uppercase font-bold text-emerald-500 mb-0.5">EV Charge</p>
                <h4 class="font-extrabold text-sm text-emerald-600 dark:text-emerald-400">฿{{ node.data.evRevenue | number }}</h4>
              </div>
            </div>
          </div>

          <!-- TYPE C: OCCUPANCY RATIO -->
          <div *ngIf="node.type === 'occupancy' && node.data" class="animate-fade-in flex items-center justify-between">
            <div class="relative w-20 h-20">
              <svg viewBox="0 0 36 36" class="w-20 h-20">
                <path class="stroke-slate-100 dark:stroke-slate-800" stroke-width="3" fill="none" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                <path class="stroke-amber-500" stroke-dasharray="100, 100" [attr.stroke-dasharray]="node.data.occupancyRate + ', 100'" stroke-width="3.2" stroke-linecap="round" fill="none" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
              </svg>
              <div class="absolute inset-0 flex items-center justify-center">
                <span class="text-xs font-black text-slate-800 dark:text-slate-100">{{ node.data.occupancyRate }}%</span>
              </div>
            </div>
            <div class="flex-1 pl-4 space-y-1">
              <p class="text-[10px] uppercase font-bold text-slate-400">Occupancy Spots</p>
              <h3 class="text-lg font-black text-slate-800 dark:text-slate-100">{{ node.data.occupiedSpots }} / {{ node.data.totalSpots }}</h3>
              <p class="text-[10px] text-slate-450">Slots occupied currently</p>
            </div>
          </div>

          <!-- TYPE D: RECENT TRANSACTIONS -->
          <div *ngIf="node.type === 'transactions' && node.data" class="animate-fade-in">
            <div class="space-y-3 max-h-40 overflow-y-auto custom-scrollbar">
              <div *ngFor="let t of node.data" class="flex items-center justify-between border-b border-slate-50 dark:border-slate-800/40 pb-2 last:border-b-0 last:pb-0">
                <div class="flex items-center gap-2.5">
                  <div class="w-8 h-8 rounded-lg bg-slate-100 dark:bg-slate-800 text-slate-500 font-bold text-xs flex items-center justify-center">
                    {{ t.licensePlate.substring(0, 2) }}
                  </div>
                  <div>
                    <h4 class="font-bold text-slate-700 dark:text-slate-350 text-xs">{{ t.licensePlate }}</h4>
                    <p class="text-[9px] text-slate-450">{{ t.timeLabel }}</p>
                  </div>
                </div>
                <div class="text-right">
                  <h4 class="font-black text-slate-700 dark:text-slate-350 text-xs">฿{{ t.amount }}</h4>
                  <p class="text-[8px] px-1.5 py-0.5 rounded bg-amber-100 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400 font-extrabold inline-block scale-90">{{ t.paymentType }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- TYPE E: MONTHLY TREND CHART -->
          <div *ngIf="node.type === 'monthly-stats' && node.data" class="animate-fade-in">
            <div class="h-28 flex items-end justify-between pt-2 px-1 relative">
              <div class="absolute inset-0 flex flex-col justify-between pointer-events-none opacity-20">
                <div class="border-b border-slate-400 w-full h-0"></div>
                <div class="border-b border-slate-400 w-full h-0"></div>
                <div class="border-b border-slate-400 w-full h-0"></div>
              </div>
              <div *ngFor="let month of node.data.labels; let idx = index" class="flex flex-col items-center flex-1 mx-1 group/bar z-10">
                <div class="w-full bg-slate-100 dark:bg-slate-800 rounded-md h-20 flex items-end overflow-hidden">
                  <div class="bg-amber-500 w-full rounded-md group-hover/bar:bg-amber-400 transition-colors"
                       [style.height.%]="(node.data.revenueData[idx] / 400) * 100">
                  </div>
                </div>
                <span class="text-[9px] font-bold text-slate-400 mt-1.5">{{ month }}</span>
              </div>
            </div>
            <div class="flex items-center justify-between mt-3 text-[10px] text-slate-400 font-bold border-t border-slate-50 dark:border-slate-800/40 pt-2">
              <span class="flex items-center gap-1"><span class="w-2 h-2 rounded-full bg-amber-50"></span> Revenue Trend</span>
              <span>Max: ฿360k</span>
            </div>
          </div>

        </div>
      </div>

      <!-- Instruction Panel placeholder when canvas is empty -->
      <div *ngIf="nodes().length === 0" 
           class="absolute inset-0 flex flex-col items-center justify-center text-slate-400 pointer-events-none p-10 text-center">
        <span class="material-icons text-6xl text-slate-350 dark:text-slate-800 mb-4">touch_app</span>
        <p class="text-base font-extrabold text-slate-750 dark:text-slate-200">บอร์ดแคนวาสว่างเปล่า</p>
        <p class="text-xs text-slate-400 dark:text-slate-500 mt-1 max-w-sm">ลากบล็อคกลุ่มข้อมูลที่ต้องการจากแถบเมนูด้านซ้ายมาวางในหน้านี้ เพื่อดึงรายงานผ่าน API และเริ่มลากสายเชื่อมต่อเปรียบเทียบข้อมูล</p>
      </div>

    </div>

    <!-- ═════ BOTTOM COMPARISON DRAWER ═════ -->
    <div *ngIf="selectedConnection() as conn" 
         class="absolute bottom-0 left-0 right-0 bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm border-t border-slate-100/50 dark:border-slate-800/50 shadow-2xl z-20 transition-all transform animate-fade-in-up duration-300">
      
      <!-- Drawer Header -->
      <div class="px-6 py-4 border-b border-slate-100/50 dark:border-slate-800/50 flex items-center justify-between bg-slate-50/50 dark:bg-slate-800/20">
        <div class="flex items-center gap-2">
          <span class="material-icons text-amber-500">compare_arrows</span>
          <h3 class="font-extrabold text-slate-800 dark:text-slate-200">เปรียบเทียบข้อมูล (Comparison Analytics)</h3>
        </div>
        <div class="flex items-center gap-3">
          <!-- Excel Export comparison -->
          <button (click)="exportComparisonToExcel()"
                  *ngIf="comparisonData() && !comparisonData()?.incompatible"
                  class="px-3 py-1.5 text-xs text-emerald-600 bg-emerald-50 dark:bg-emerald-950/20 rounded-xl hover:bg-emerald-100 transition-colors font-bold flex items-center gap-1 border border-emerald-100/50 cursor-pointer">
            <span class="material-icons text-sm">download</span> ส่งออก Excel
          </button>
          <!-- Close comparison -->
          <button (click)="clearComparison()" class="text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition-colors p-1 rounded-lg cursor-pointer">
            <span class="material-icons">close</span>
          </button>
        </div>
      </div>

      <!-- Drawer Content -->
      <div class="p-6 max-h-60 overflow-y-auto custom-scrollbar">
        
        <div *ngIf="!comparisonData()" class="py-10 text-center text-slate-400">
          <div class="w-6 h-6 rounded-full border-2 border-slate-200 border-t-amber-500 animate-spin mx-auto mb-2"></div>
          <p class="text-xs">กำลังประมวลผลข้อมูลเปรียบเทียบ...</p>
        </div>

        <div *ngIf="comparisonData() as data">
          
          <div *ngIf="data.incompatible" class="py-6 text-center text-amber-600 dark:text-amber-400 font-bold flex flex-col items-center justify-center">
            <span class="material-icons text-3xl mb-2">warning</span>
            <p>{{ data.msg }}</p>
          </div>

          <div *ngIf="!data.incompatible">
            
            <div class="grid grid-cols-1 md:grid-cols-3 gap-6 items-center">
              
              <!-- Left side Node A details -->
              <div class="p-4 bg-slate-50 dark:bg-slate-800/30 rounded-2xl border border-slate-100 dark:border-slate-800">
                <p class="text-xs text-slate-400 font-bold uppercase tracking-wider mb-2">กลุ่มต้นทาง A</p>
                <h4 class="font-black text-slate-700 dark:text-slate-200 mb-3 truncate">{{ data.titleA }}</h4>
                
                <div *ngIf="data.type === 'total-cars'">
                  <div class="flex justify-between items-end mb-1">
                    <span class="text-xs text-slate-400">Active / Reg</span>
                    <span class="text-base font-black text-slate-800 dark:text-slate-100">{{ data.activeA }}</span>
                  </div>
                  <p class="text-[10px] text-slate-400">Ratio: {{ data.percentageA }}%</p>
                </div>
                <div *ngIf="data.type === 'revenue'">
                  <h3 class="text-xl font-black text-amber-500">฿{{ data.revenueA | number }}</h3>
                  <div class="flex gap-2 text-[10px] text-slate-400 mt-2">
                    <span>EV: ฿{{ data.evA | number }}</span>
                    <span>จอด: ฿{{ data.parkingA | number }}</span>
                  </div>
                </div>
                <div *ngIf="data.type === 'occupancy'">
                  <h3 class="text-xl font-black text-slate-800 dark:text-slate-100">{{ data.rateA }}%</h3>
                  <p class="text-xs text-slate-400 mt-1">ใช้งาน: {{ data.occupiedA }} ช่องจอด</p>
                </div>
              </div>

              <!-- Center Compare stats comparison logic bubble -->
              <div class="text-center p-4">
                <span class="text-[10px] font-black tracking-widest text-slate-400 uppercase block mb-2">เปรียบเทียบผลต่าง</span>
                
                <div *ngIf="data.type === 'total-cars'">
                  <div class="w-16 h-16 rounded-full bg-amber-500 text-white font-black text-lg flex items-center justify-center mx-auto shadow-lg mb-2">
                    {{ data.diffActive > 0 ? '+' : '' }}{{ data.diffActive }}
                  </div>
                  <p class="text-xs font-bold text-slate-500">ผลต่างรถวิ่งรวม</p>
                </div>

                <div *ngIf="data.type === 'revenue'">
                  <div class="w-16 h-16 rounded-full bg-amber-500 text-white font-black text-sm flex items-center justify-center mx-auto shadow-lg mb-2">
                    {{ data.percentDiff > 0 ? '+' : '' }}{{ data.percentDiff }}%
                  </div>
                  <p class="text-xs font-bold text-slate-500">ผลต่างรายได้รวม</p>
                </div>

                <div *ngIf="data.type === 'occupancy'">
                  <div class="w-16 h-16 rounded-full bg-amber-500 text-white font-black text-sm flex items-center justify-center mx-auto shadow-lg mb-2">
                    {{ data.diffRatePositive ? '+' : '' }}{{ data.diffRate }}%
                  </div>
                  <p class="text-xs font-bold text-slate-500">อัตราจอดต่างกัน</p>
                </div>

                <div *ngIf="data.type === 'monthly-stats'">
                  <div class="w-12 h-12 rounded-full bg-amber-100 dark:bg-amber-900/30 text-amber-500 flex items-center justify-center mx-auto mb-1">
                    <span class="material-icons">query_stats</span>
                  </div>
                  <p class="text-xs font-bold text-slate-500">เปรียบเทียบรายเดือนย้อนหลัง</p>
                </div>
              </div>

              <!-- Right side Node B details -->
              <div class="p-4 bg-slate-50 dark:bg-slate-800/30 rounded-2xl border border-slate-100 dark:border-slate-800">
                <p class="text-xs text-slate-400 font-bold uppercase tracking-wider mb-2">กลุ่มปลายทาง B</p>
                <h4 class="font-black text-slate-700 dark:text-slate-200 mb-3 truncate">{{ data.titleB }}</h4>
                
                <div *ngIf="data.type === 'total-cars'">
                  <div class="flex justify-between items-end mb-1">
                    <span class="text-xs text-slate-400">Active / Reg</span>
                    <span class="text-base font-black text-slate-800 dark:text-slate-100">{{ data.activeB }}</span>
                  </div>
                  <p class="text-[10px] text-slate-400">Ratio: {{ data.percentageB }}%</p>
                </div>
                <div *ngIf="data.type === 'revenue'">
                  <h3 class="text-xl font-black text-amber-500">฿{{ data.revenueB | number }}</h3>
                  <div class="flex gap-2 text-[10px] text-slate-400 mt-2">
                    <span>EV: ฿{{ data.evB | number }}</span>
                    <span>จอด: ฿{{ data.parkingB | number }}</span>
                  </div>
                </div>
                <div *ngIf="data.type === 'occupancy'">
                  <h3 class="text-xl font-black text-slate-800 dark:text-slate-100">{{ data.rateB }}%</h3>
                  <p class="text-xs text-slate-400 mt-1">ใช้งาน: {{ data.occupiedB }} ช่องจอด</p>
                </div>
              </div>

            </div>

            <!-- Detailed month-on-month comparison table -->
            <div *ngIf="data.type === 'monthly-stats'" class="mt-6 border-t border-slate-100 dark:border-slate-800/60 pt-4">
              <h4 class="text-xs font-black uppercase text-slate-400 tracking-wider mb-3">สรุปผลต่างแต่ละเดือน (Revenue Diff)</h4>
              <div class="grid grid-cols-6 gap-2 text-center text-[10px] font-bold">
                <div *ngFor="let item of data.items" class="bg-slate-50 dark:bg-slate-800/40 p-2 rounded-xl border border-slate-100 dark:border-slate-800">
                  <p class="text-slate-400 mb-1">{{ item.month }}</p>
                  <p class="text-slate-700 dark:text-slate-350 font-bold">A: ฿{{ item.valA }}k</p>
                  <p class="text-slate-700 dark:text-slate-350 font-bold">B: ฿{{ item.valB }}k</p>
                  <p class="font-extrabold mt-1" [ngClass]="item.diff > 0 ? 'text-emerald-600' : 'text-rose-500'">
                    {{ item.diff > 0 ? '+' : '' }}{{ item.diff }}k
                  </p>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>

  </main>
  
</div>

<!-- Loader overlay for components -->
<app-pss-loading *ngIf="isLoading()"></app-pss-loading>